// Chakra imports
import { Box, Text, Flex, Switch, useColorModeValue, Icon, Link } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React from "react";
import { useTranslation } from 'react-i18next';
import { AiOutlineExclamationCircle } from 'react-icons/ai';

export default function ToggleInformation(props) {
  const { title, value, disabled, onChange, hint, ...rest } = props;
  const { t } = useTranslation();
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const bg = useColorModeValue("white", "navy.700");
  const isMissing = !disabled && (value === undefined || value === null);

  return (
    <Card bg={bg} {...rest}>
      <Flex align='center' direction={{ base: "column", md: "row" }}>
        <Box maxW='100%'>
          <Flex align='center'>
            <Text fontWeight='500' color={textColorSecondary} fontSize='sm' isTruncated>
              {t(title)}
            </Text>
            {isMissing && (
              <Icon
                as={AiOutlineExclamationCircle}
                color='red.400'
                ml='6px'
                boxSize='14px'
                title={t('This field is required')}
                aria-label={t('This field is required')}
              />
            )}
          </Flex>
          <Text color={textColorPrimary} fontWeight='500' fontSize='md' isTruncated>
            {value ? t('Enabled') : t('Disabled')}
          </Text>
          {hint && (
            <Text fontSize='xs' color={'red'} ml='5px'>
              {t(hint)}
            </Text>
          )}
        </Box>
        <Flex ml={{ base: 0, md: 'auto' }} mt={{ base: 2, md: 0 }} align='center' gap={4}>
          <Switch
            isChecked={!!value}
            onChange={(e) => onChange(e.target.checked)}
            isDisabled={disabled}
            colorScheme='brand'
            size='md'
            aria-label={t(title)}
          />
        </Flex>
      </Flex>
    </Card>
  );
}